import React from 'react';
import type { ReactNode } from 'react';
import useStyles from '../../theme/useStyles';

// Replaces window.confirm(), which cannot be styled and blocks the thread.
//
//   const [pendingDelete, setPendingDelete] = useState(null);
//   <ConfirmDialog
//     open={!!pendingDelete}
//     message={`Delete ${pendingDelete?.name}?`}
//     onConfirm={() => { remove(pendingDelete.id); setPendingDelete(null); }}
//     onCancel={() => setPendingDelete(null)}
//   />
export interface ConfirmDialogProps {
  open?: boolean;
  title?: string;
  message?: ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  /** Renders the confirm button in red. Defaults to true. */
  destructive?: boolean;
  onConfirm?: () => void;
  onCancel?: () => void;
  isDarkMode?: boolean;
}

const ConfirmDialog = ({
  open = false,
  title = 'Please confirm',
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  destructive = true,
  onConfirm,
  onCancel,
  isDarkMode
}: ConfirmDialogProps) => {
  const s = useStyles(isDarkMode);
  if (!open) return null;

  return (
    <div style={s.notificationOverlay} onClick={onCancel}>
      <div
        style={{ ...s.notificationBox, borderTop: `5px solid ${destructive ? s.t.danger : s.t.primary}` }}
        onClick={(e) => e.stopPropagation()}
        role="alertdialog"
        aria-modal="true"
      >
        <h4 style={s.notificationTitle}>{title}</h4>
        <p style={s.notificationText}>{message}</p>
        <div style={{ display: 'flex', gap: '10px' }}>
          <button style={{ ...s.viewBtn, flex: 1, padding: '10px' }} onClick={onCancel}>
            {cancelLabel}
          </button>
          <button
            autoFocus
            style={{
              ...(destructive ? s.dangerBtn : s.submitBtn),
              flex: 1, padding: '10px', fontSize: '15px'
            }}
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
